export default __webpack_public_path__ + "static/media/EmailIcon.d6e8158d.svg";